import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useLeadTableFilterV2 = (props: { pipeId?: number; page?: number | null } = {}) =>
  useQuery<crmModels.ILeadTableFilterV2>({
    queryKey: [crmConstants.queryKeys.LEAD_TABLE_FILTER_V2, props],
    queryFn: async () => {
      const res = await $api.post('/v1/lead/table-filter/v2', props);

      const data: crmModels.ILeadTableFilterV2 = res?.data?.data;

      return {
        ...data,
        leadList: {
          ...data?.leadList,
          data: data?.leadList?.data?.map(item => ({
            ...item,
            createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp })
          }))
        }
      };
    }
  });
